import { Fragment } from "react/jsx-runtime";
import ShortCuts from "./ShortCuts";

const Dashboard = () => {
  return (
    <Fragment>
      <ShortCuts />
    </Fragment>
  );
};

export default Dashboard;
